// extracted by mini-css-extract-plugin
module.exports = {"lead":"Typography_lead__3RqP-","contact":"Typography_contact__OELnP","legal":"Typography_legal__SwO70"};